import React, { useEffect, useState } from 'react';
import LocalizedText from '../../presentational/LocalizedText';
import useTranslate from "../../../hooks/useTranslate";
import { isValidEmail } from "../utils";
import Button from "../../presentational/Button";
import Input from "../../presentational/Input";
import { useTurnstile } from "../../../hooks/useTurnstile";
interface VerifyNonceProps {
  serverError: string;
  isLoading: boolean;
  emailOrPhone: string;
  verifyPasswordResetNonce: (emailOrPhone: string, verificationCode: string) => void;
  forgotPassword: () => void;
}

const VerifyNonce: React.FC<VerifyNonceProps> = ({
  serverError,
  isLoading,
  emailOrPhone,
  verifyPasswordResetNonce,
  forgotPassword,
}) => {
  const [verificationCode, setVerificationCode] = useState('')
  const translations = useTranslate(["participant-login-verification-code-label", "participant-login-next-label"])
  useTurnstile();

  const handleSubmit = () => {
    verifyPasswordResetNonce(emailOrPhone, verificationCode)
    return false
  }

  return (
    <form className="login-action" onSubmit={handleSubmit}>
      <h3><LocalizedText textKey="participant-login-verify-nonce-title" /></h3>
      <p style={{textAlign:'left',marginBottom: '8px'}}><LocalizedText textKey={isValidEmail(emailOrPhone) ? "participant-login-verify-nonce-info" : "participant-login-verify-nonce-info-phone"} values={{ emailOrPhone: emailOrPhone }} /></p>
      {
        serverError && (
          <p className="server-error">{serverError}</p>
        )
      }
      <div className="field-group">
        <label htmlFor="verificationCode" className="">{translations["participant-login-verification-code-label"]}</label>
        <Input
          autoComplete="one-time-code"
          className="autofocus"
          disabled={isLoading}
          onChange={(e) => setVerificationCode(e.target.value)}
          id="verificationCode"
          type="tel"
          value={verificationCode}
          placeholder="123-123-1234"
          fullWidth={true}
          htmlAttributes={{
            pattern: "[0-9]{3}-[0-9]{3}-[0-9]{4}",
            maxLength: 12,
            spellCheck: "false",
            autoCorrect: "off",
            autoCapitalize: "none",
          }}
        />
      </div>
      <div>
        <div id="cf-turnstile" className="cf-turnstile"></div>
        <Button
          onClick={handleSubmit}
          disabled={!verificationCode.length}
          className="primary-action"
          width="100%"
          intent='primary'
          loading={isLoading}
          type='submit'
        >
          <span dangerouslySetInnerHTML={{ __html: translations["participant-login-next-label"] }} />
        </Button>
      </div>
    </form>
  )
}

export default VerifyNonce